import { render, staticRenderFns } from "./twilio-voice-insights-tab.vue?vue&type=template&id=05eda994&scoped=true"
import script from "./twilio-voice-insights-tab.vue?vue&type=script&lang=js"
export * from "./twilio-voice-insights-tab.vue?vue&type=script&lang=js"
import style0 from "./twilio-voice-insights-tab.vue?vue&type=style&index=0&id=05eda994&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05eda994",
  null
  
)

export default component.exports